import type { Column } from '@tanstack/react-table';
import { useExternalOptions } from '../filter/ExternalFilterOptionsContext';
import { useTranslateValue } from './useTranslateValue';

export const useFilterLabel = (
  column: Column<any, any> | undefined
): unknown => {
  const value = column?.getFilterValue();
  const translated = useTranslateValue(value, column);
  const externalOptions = useExternalOptions(column);

  if (externalOptions) {
    return externalOptions.find((o) => o.id === value)?.displayName;
  }
  if (column?.columnDef?.meta?.filterLabel) {
    return column.columnDef.meta.filterLabel(translated, { column });
  }
  if (Array.isArray(translated)) {
    return translated.join(' ... ');
  }
  return translated;
};
